import { EventModel } from '@frontend/sports/betting-offer/feature/model';
import { Alert } from '@frontend/sports/types/components/native-alert';

import { ISucceededSlipPickResult } from '../../betslip/modules/betplacement/models';
import { AlertEvent, AlertMetaData, IMyBetsAlertData, IScoreboardLiveAlert } from './model';

export function extractIds(alert: Alert): number[] {
    if (!alert.id && alert.containedAlerts) {
        return alert.containedAlerts.filter((x) => x.id !== null).map((x) => x.id as number);
    }

    return !alert.id ? [] : [alert.id];
}

export function getBetslipModel(
    items: ISucceededSlipPickResult[],
    alertMetaData: AlertMetaData,
    isSportEnabled: (sportId: number) => boolean,
): AlertEvent[] {
    const result: AlertEvent[] = [];

    items.forEach((item: ISucceededSlipPickResult) => {
        if (item.clientPick?.liveAlert && isSportEnabled(item.clientPick.sportId)) {
            result.push({
                sportId: item.clientPick.sportId,
                eventId: item.pickId.fixtureId,
                leagueId: item.clientPick.competitionId,
                title: item.clientPick.eventName?.name,
                live: item.clientPick.isLive,
                marketIds: item.clientPick.market?.id ? [item.clientPick.market?.id] : alertMetaData.marketIds,
                betNumber: alertMetaData.betNumbers,
                betType: alertMetaData.betType,
            });
        }
    });

    return result;
}

export function getEventModel(item: EventModel): AlertEvent[] {
    const result: AlertEvent[] = [];
    if (item.liveAlert) {
        result.push({
            sportId: item.sport.id,
            eventId: item.id,
            leagueId: item.league.id,
            title: item.name,
            eventGroupId: item.groupId,
            leagueGroupId: item.league.parentLeagueId,
            live: item.live,
        });
    }

    return result;
}

export function getScoreboardModel(item: IScoreboardLiveAlert): AlertEvent[] {
    const result: AlertEvent[] = [];
    if (item.liveAlert) {
        result.push({
            sportId: item.sportId,
            eventId: item.eventId,
            leagueId: item.leagueId,
            title: item.title,
            eventGroupId: item.eventGroupId,
            leagueGroupId: item.leagueGroupId,
            live: item.live,
        });
    }

    return result;
}

export function getMyBetsModel(items: IMyBetsAlertData[], alertMetaData: AlertMetaData): AlertEvent[] {
    let result: AlertEvent[] = [];

    items?.forEach((item: IMyBetsAlertData) => {
        if (item.liveAlert) {
            result.push({
                sportId: item.sportsId,
                eventId: item.eventId,
                leagueId: item.leagueId,
                title: item.eventName,
                eventGroupId: item.eventGroupId,
                leagueGroupId: item.leagueGroupId,
                live: item.containsLiveBets,
                betType: alertMetaData.betType,
                betNumber: alertMetaData.betNumbers,
                marketIds: item.marketId ? [item.marketId] : alertMetaData.marketIds,
            });
        }
    });

    return result;
}
